module.exports = __webpack_public_path__ + "img/2.0f769635.png";